<template>
  <div class="page_content create-section">
    <div class="hidden-container">
      <form method="POST" id="subOrgLogoUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
        <input type="file" id="subOrgThumbnailFileList" ref="subOrgThumbnailFileList" name="thumbnailFile" accept=".jpg,.jpeg,.bmp,.gif,.png" @change="thumbnailToBeUploaded" />
      </form>
    </div>
    <div class="page_heading">
      <div class="col-5 module_heading">
        <span class="module_icon ico-employer"></span>
        <span class="module_title">{{ pageTitle }}</span>
      </div>
      <div class="col-7 btn_container">
        <button class="btn btn-primary" :disabled="submitted" @click="saveSubOrg" aria-label="save">save</button>
        <button class="btn btn-primary" :disabled="submitted" @click="cancel" aria-label="cancel">cancel</button>
      </div>
    </div>

    <div class="content-section">
      <div class="row content-row employer-top-row">
        <div class="col-6 row employer-left-col">
          <div class="col-4 form-label" id="subOrgTitle">{{ $t('title') }} <sup>*</sup></div>
          <div class="col-7"><input v-model="form.title" aria-labelledby="subOrgTitle" :placeholder="$t('title')"></div>
          <div class="col-4 form-label" id="subOrgWebsite">{{ $t('websiteTitle') }}</div>
          <div class="col-7"><input v-model="form.website" aria-labelledby="subOrgWebsite" placeholder="https://"></div>
          <div class="col-4 form-label" id="subOrgContactTitle">{{ $t('contactTitle') }}</div>
          <div class="col-7"><input v-model="form.contactTitle" aria-labelledby="subOrgContactTitle" :placeholder="$t('contactTitle')"></div>
          <div class="col-4 form-label" id="subOrgContactName">{{ $t('contactName') }}</div>
          <div class="col-7"><input v-model="form.contactName" aria-labelledby="subOrgContactName" :placeholder="$t('contactName')"></div>
          <div class="col-4 form-label" id="subOrgEmail">{{ $t('email') }}</div>
          <div class="col-7"><input v-model="form.email" aria-labelledby="subOrgEmail" :placeholder="$t('email')"></div>
        </div>
        <div class="col-6 row employer-logo-col">
          <div class="col-4 form-label" id="subOrgLogo">{{ $t('logo') }}</div>
          <div class="col-7">
            <div class="employer-logo-box">
              <div class="thumbnail_container">
                <button type="button" class="btn" @click="addThumbnailClicked">upload logo</button>
                <img v-if="showPreview && logoUri" :src="logoUri" class="thumbnail_image" alt="">
                <span v-else class="ic ico-employer"></span>
              </div>
            </div>
            <b-modal ref="subOrgThumbnailModal" id="addSubOrgThumbnail" v-model="showAddThumbnailModal" ok-disabled cancel-disabled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup popup_add_thumbnail">
              <div slot="modal-header" class="popover-header">
                <div class="popup-heading">Update Thumbnail</div>
                <button class="btn_close" aria-label="close" @click="cancelAddThumbnail">
                  <span class="ic-close"></span>
                </button>
              </div>
              <div class="row">
                <div class="col-4">
                  <div class="thumbnail_msg">How your thumbnail will appear</div>
                  <div class="thumbnail_container">
                    <img v-if="showPreview && logoUri" :src="logoUri" alt="">
                    <span v-else class="ic ico-employer"></span>
                  </div>
                  <b-btn v-if="logo && logo.length > 0" @click.stop="removeThumbnailClicked" class="btn">remove logo</b-btn>
                  <span v-if="!showPreview">Preview unavailable</span>
                </div>
                <div class="col-7 right-model-box">
                  <div class="row fld_row">
                    <div class="col-1 fld_col_label">
                      <label>URL</label>
                    </div>
                    <div class="col-8 fld_col_input">
                      <input v-model="logoUri" placeholder="http://">
                    </div>
                    <div class="col-3 btn_container"></div>
                  </div>
                  <div class="row fld_row msg_row">
                    <div class="col-1"></div>
                    <div class="col-11 msg">Add image url for thumbnail.</div>
                  </div>
                  <div class="row txt_sep_row">
                    <div class="col-12">OR</div>
                  </div>
                  <div class="row fld_row">
                    <div class="col-1 fld_col_label">
                      <label for="subOrgThumbnailFileName">File</label>
                    </div>
                    <div class="col-8 fld_col_input">
                      <input id="subOrgThumbnailFileName" disabled v-model="logo" placeholder="choose a file from your computer">
                    </div>
                    <div class="col-3 fld_col_btn">
                      <b-btn @click.stop="chooseFile">add file</b-btn>
                    </div>
                  </div>
                  <div class="row msg_row">
                    <div class="col-1"></div>
                    <div class="col-11 msg">Select a jpg, jpeg, bmp, gif or png file.</div>
                  </div>
                </div>
              </div>
              <div slot="modal-footer">
                <b-btn @click="addNewThumbnail">save and next</b-btn>
                <b-btn @click="cancelAddThumbnail">cancel</b-btn>
              </div>
            </b-modal>
          </div>
        </div>
      </div>

      <div class="row content-row job-description-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="subOrgDescription">{{ $t('description') }}</div>
          <div class="col-7" ref="descriptionStart">
            <div ref="descriptionInput" class="job-description-input">
              <editor
                v-model.trim="form.description"
                :init="editorInit"
                @onInit="onEditorInit('subOrgDescriptionId_ifr')"
                id="subOrgDescriptionId">
              </editor>
            </div>
          </div>
        </div>
        <div class="col-6 row job-description-end-col">
          <div class="col-4"></div>
          <div class="col-7" ref="descriptionEnd"></div>
        </div>
      </div>

      <div class="row content-row job-description-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="subOrgMission">{{ $t('mission') }}</div>
          <div class="col-7" ref="missionStart">
            <div ref="missionInput" class="job-description-input">
              <editor
                v-model.trim="form.mission"
                :init="editorInit"
                @onInit="onEditorInit('subOrgMissionId_ifr')"
                id="subOrgMissionId">
              </editor>
            </div>
          </div>
        </div>
        <div class="col-6 row job-description-end-col">
          <div class="col-4"></div>
          <div class="col-7" ref="missionEnd"></div>
        </div>
      </div>

      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="subOrgPhone">{{ $t('phone') }}</div>
          <div class="col-7"><input v-model="form.phone" aria-labelledby="subOrgPhone" :placeholder="$t('phone')"></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="subOrgFax">{{ $t('fax') }}</div>
          <div class="col-7"><input v-model="form.fax" aria-labelledby="subOrgFax" :placeholder="$t('fax')"></div>
        </div>
      </div>

      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="subOrgCity">{{ $t('city') }}</div>
          <div class="col-7"><input v-model="form.city" aria-labelledby="subOrgCity" :placeholder="$t('city')"></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="subOrgState">{{ $t('state') }}</div>
          <div class="col-7"><input v-model="form.state" aria-labelledby="subOrgState" :placeholder="$t('state')"></div>
        </div>
      </div>

      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="subOrgCountry">{{ $t('country') }}</div>
          <div class="col-7"><input v-model="form.country" aria-labelledby="subOrgCountry" :placeholder="$t('country')"></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="subOrgAddress">{{ $t('address') }}</div>
          <div class="col-7"><input v-model="form.address" aria-labelledby="subOrgAddress" :placeholder="$t('address')"></div>
        </div>
      </div>

      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="subOrgFacebook">{{ $t('facebook') }}</div>
          <div class="col-7"><input v-model="form.facebookUri" aria-labelledby="subOrgFacebook" placeholder="https://"></div>
        </div>
        <div class="col-6 row">
          <div class="col-4 form-label" id="subOrgLinkedin">{{ $t('linkedin') }}</div>
          <div class="col-7"><input v-model="form.linkedinUri" aria-labelledby="subOrgLinkedin" placeholder="https://"></div>
        </div>
      </div>
      <div class="row content-row">
        <div class="col-6 row">
          <div class="col-4 form-label" id="subOrgYoutube">{{ $t('youtube') }}</div>
          <div class="col-7"><input v-model="form.youtubeUri" aria-labelledby="subOrgYoutube" placeholder="https://"></div>
        </div>
      </div>

    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  /* global AWS:true */
  import { mapState, mapActions } from 'vuex'
  import Editor from '@tinymce/tinymce-vue'
  import _ from 'lodash'
  import { AwsObject } from '../../institution/aws'
  import '../../../assets/module/css/user/userList.min.css'
  import employerSettingsFlags from '../employerSettingsFlags'

  var getFileName = function (fileName) {
    if (!fileName && fileName !== null) {
      return null
    }
    return fileName.replace(/\.\w+$/g, '')
  }

  var getUpdatedFileName = function (title, fileName) {
    var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
    if (ext !== '' || ext !== null) {
      return (title + '.' + ext)
    } else {
      return fileName
    }
  }

  var FileObject = function (title, file, size, timestamp, type) {
    this.title = getFileName(title)
    this.file = file
    this.fileName = getUpdatedFileName(this.title, title)
    this.size = size
    this.contentFileType = type
    this.timestamp = timestamp
    this.id = timestamp
  }

  var clone = function (obj) {
    if (obj === null || typeof obj !== 'object') return obj
    var copy = obj.constructor()
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
    }
    return copy
  }

  export default {
    name: 'createEditSubOrg',
    mixins: [employerSettingsFlags],
    props: ['uuid', 'subOrgId'],
    components: {
      Editor
    },
    data: () => {
      return {
        submitted: false,
        sourceSubOrg: null,
        fileUploadArray: [],
        isEditingThumbnail: false,
        logo: '',
        logoCopy: '',
        logoUri: '',
        logoUriCopy: '',
        showAddThumbnailModal: false,
        showPreview: true,
        plugins: 'charmap code hr link searchreplace textcolor autoresize media image imagetools table lists',
        toolbar: 'undo redo  bold italic underline bullist numlist outdent indent link unlink alignleft aligncenter alignright alignjustify media insertfile image table forecolor backcolor | searchreplace removeformat | fontselect fontsizeselect styleselect',
        form: {
          title: '',
          description: '',
          mission: '',
          logo: '',
          website: '',
          city: '',
          state: '',
          country: '',
          address: '',
          contactTitle: '',
          contactName: '',
          phone: '',
          fax: '',
          email: '',
          youtubeUri: '',
          facebookUri: '',
          linkedinUri: ''
        }
      }
    },
    mounted () {
      this.loadCurrentEnvironment().then(res => {
        AwsObject(res)
      })
      this.loadPage()
      this.alignHtmlEditors()
      window.addEventListener('resize', this.alignHtmlEditors)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.alignHtmlEditors)
    },
    methods: {
      ...mapActions([
        'loadSubOrganization',
        'createSubOrganization',
        'updateSubOrganization',
        'loadCurrentEnvironment',
        'uploadContentAndGetUri',
        'updateFileUriAndVersionIdAfterS3Upload'
      ]),
      loadPage () {
        if (this.isEdit && this.subOrganizationId) {
          this.loadSubOrganization(this.subOrganizationId).then((subOrg) => {
            this.populateForm(subOrg || {})
            this.alignHtmlEditors()
          })
        } else {
          this.resetForm()
        }
        this.$nextTick(this.alignHtmlEditors)
      },
      resetForm () {
        this.sourceSubOrg = null
        this.form.title = ''
        this.form.description = ''
        this.form.mission = ''
        this.form.logo = ''
        this.logo = ''
        this.logoUri = ''
        this.showPreview = true
        this.form.website = ''
        this.form.city = ''
        this.form.state = ''
        this.form.country = ''
        this.form.address = ''
        this.form.contactTitle = ''
        this.form.contactName = ''
        this.form.phone = ''
        this.form.fax = ''
        this.form.email = ''
        this.form.youtubeUri = ''
        this.form.facebookUri = ''
        this.form.linkedinUri = ''
      },
      populateForm (subOrg) {
        this.sourceSubOrg = this.cloneSubOrg(subOrg)
        this.form.title = subOrg.title || ''
        this.form.description = subOrg.description || ''
        this.form.mission = subOrg.mission || ''
        this.form.logo = subOrg.logo || ''
        this.logo = subOrg.logo || ''
        this.logoUri = subOrg.logo || ''
        this.showPreview = true
        this.form.website = subOrg.website || ''
        this.form.city = subOrg.city || ''
        this.form.state = subOrg.state || ''
        this.form.country = subOrg.country || ''
        this.form.address = subOrg.address || ''
        this.form.contactTitle = subOrg.contanctTitle || subOrg.contactTitle || ''
        this.form.contactName = subOrg.contanctName || subOrg.contactName || ''
        this.form.phone = subOrg.phone || ''
        this.form.fax = subOrg.fax || ''
        this.form.email = subOrg.email || ''
        this.form.youtubeUri = subOrg.youtubeUri || ''
        this.form.facebookUri = subOrg.facebookUri || ''
        this.form.linkedinUri = subOrg.linkedinUri || ''
      },
      cloneSubOrg (subOrg) {
        if (!subOrg) {
          return {}
        }
        try {
          return JSON.parse(JSON.stringify(subOrg))
        } catch (e) {
          return Object.assign({}, subOrg)
        }
      },
      alignHtmlEditors () {
        this.alignFullRowEditor('descriptionStart', 'descriptionEnd', 'descriptionInput')
        this.alignFullRowEditor('missionStart', 'missionEnd', 'missionInput')
      },
      alignFullRowEditor (startRef, endRef, inputRef) {
        this.$nextTick(() => {
          let start = this.$refs[startRef]
          let end = this.$refs[endRef]
          let input = this.$refs[inputRef]
          if (!start || !end || !input) {
            return
          }
          let startRect = start.getBoundingClientRect()
          let endRect = end.getBoundingClientRect()
          let startStyle = window.getComputedStyle(start)
          let endStyle = window.getComputedStyle(end)
          let width = endRect.right - parseFloat(endStyle.paddingRight) - startRect.left - parseFloat(startStyle.paddingLeft)
          if (width > 0) {
            input.style.width = width + 'px'
            let editorEl = input.querySelector('.tox-tinymce') || input.querySelector('.mce-tinymce')
            if (editorEl) {
              editorEl.style.width = width + 'px'
            }
          }
        })
      },
      onEditorInit (iframeId) {
        $('#' + iframeId).css({width: '100%', height: '250px', border: '1px solid #ccc'})
        this.alignHtmlEditors()
      },
      addThumbnailClicked () {
        this.showAddThumbnailModal = true
        this.isEditingThumbnail = true
        this.logoUriCopy = (this.logoUri || '').slice(0)
        this.logoCopy = (this.logo || '').slice(0)
      },
      removeThumbnailClicked () {
        this.isEditingThumbnail = true
        this.showPreview = true
        this.logo = ''
        this.logoUri = ''
      },
      cancelAddThumbnail () {
        this.logo = this.logoCopy
        this.logoUri = this.logoUriCopy
        this.isEditingThumbnail = false
        this.showAddThumbnailModal = false
        this.fileUploadArray = []
        this.showPreview = true
      },
      addNewThumbnail () {
        if (this.logo !== this.logoUri) {
          this.logo = this.logoUri
          this.form.logo = this.logoUri
          this.showPreview = true
        } else {
          this.uploadFiles()
        }
        this.showAddThumbnailModal = false
        this.isEditingThumbnail = false
      },
      chooseFile () {
        $('#subOrgThumbnailFileList').click()
      },
      thumbnailToBeUploaded (ev) {
        this.fileUploadArray = []
        var files = ev.target.files || ev.dataTransfer.files
        if (!files.length || files.length <= 0) {
          return
        }
        this.logoUri = files[0].name
        this.logo = files[0].name
        this.prepareFileUploadArray(files)
        this.showPreview = false
      },
      prepareFileUploadArray (files) {
        if (!files || files.length === 0) {
          return
        }
        let timestamp = new Date().getTime()
        for (var i = 0; i < files.length; i++) {
          timestamp = timestamp + i
          this.addFileToUploadArray(files[i], timestamp)
        }
      },
      addFileToUploadArray (newFile, timestamp) {
        let isFound = _.find(this.fileUploadArray, function (file) {
          return ((newFile.name === file.title) && (newFile.size === file.size))
        })
        if (!isFound) {
          this.fileUploadArray.push(new FileObject(newFile.name, newFile, newFile.size, timestamp, newFile.type))
        }
      },
      uploadFiles () {
        let fileUploadArrayClone = clone(this.fileUploadArray)
        let contentListToCreate = []
        for (var i = 0; i < fileUploadArrayClone.length; i++) {
          let content = fileUploadArrayClone[i]
          contentListToCreate.push({
            'title': content.title,
            'lastModifiedDate': content.contentFileType.timestamp,
            'contentFileType': content.contentFileType,
            'fileName': content.fileName,
            'timestamp': content.timestamp,
            'logo': content.logo,
            'logoUri': content.logoUri
          })
        }
        if (contentListToCreate.length <= 0) {
          this.form.logo = this.logoUri
          return
        }
        this.showLoader()
        this.uploadContentAndGetUri({
          learningSpaceId: this.logoUploadSpaceId,
          contents: contentListToCreate,
          success: this.uploadFileAfterCreateContentSuccessCallback,
          failure: this.uploadFileAfterCreateContentErrorCallback
        })
      },
      uploadFileAfterCreateContentSuccessCallback (response) {
        var createdContents = response.createdContents
        if (createdContents.length > 0) {
          var fileUploadArrayClone = clone(this.fileUploadArray)
          this.uploadLearningContentFilesOnS3(createdContents, fileUploadArrayClone)
        }
        this.fileUploadArray = []
        this.showPreview = true
      },
      uploadFileAfterCreateContentErrorCallback (response) {
        console.log('Error occured while creating content(s) ', response)
        this.hideLoader()
        this.notifyFailure('Unable to upload logo.')
      },
      uploadLearningContentFilesOnS3 (createdContents, fileUploadArrayClone) {
        var filesToBeUploaded = []
        $.each(createdContents, (index, content) => {
          for (var i = 0; i < fileUploadArrayClone.length; i++) {
            var fileData = fileUploadArrayClone[i]
            if (content.fileName === fileData.fileName) {
              var key = content.uuid + '-' + content.fileName
              filesToBeUploaded.push({'uuid': content.uuid, 'key': key, 'uri': content.uri, 'fileData': fileData})
              break
            }
          }
        })
        if (filesToBeUploaded.length > 0) {
          this.storeFilesToS3(filesToBeUploaded)
        } else {
          this.hideLoader()
        }
      },
      storeFilesToS3 (filesToBeUploaded) {
        var awsRef = new AWS.S3()
        var s3Bucket = this.currentEnvironment.s3Bucket
        $.each(filesToBeUploaded, (i, item) => {
          var params = {
            Key: item.key,
            Bucket: s3Bucket,
            ContentType: item.fileData.contentFileType,
            ACL: 'public-read',
            Body: item.fileData.file
          }
          awsRef.putObject(params, (err, data) => {
            if (err) {
              console.log('Uploading Sub Organization Logo Failed On S3: ' + err.stack)
              this.notifyFailure('Unable to upload logo.')
            } else {
              var uri = item.uri
              if (uri.indexOf('?versionId=') === -1 && data && data.VersionId) {
                uri = uri.concat('?versionId=' + data.VersionId)
                this.updateFileUriAndVersionIdAfterS3Upload({uuid: item.uuid, uri: uri})
              }
              this.logoUri = uri
              this.logo = uri
              this.form.logo = uri
              this.showPreview = true
            }
            this.hideLoader()
          })
        })
      },
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      buildPayload () {
        let payload = this.cloneSubOrg(this.sourceSubOrg || {})
        payload.parentId = this.employerUuid
        payload.title = this.form.title
        payload.description = this.form.description
        payload.mission = this.form.mission
        payload.logo = this.form.logo
        payload.website = this.form.website
        payload.city = this.form.city
        payload.state = this.form.state
        payload.country = this.form.country
        payload.address = this.form.address
        payload.contanctTitle = this.form.contactTitle
        payload.contanctName = this.form.contactName
        payload.phone = this.form.phone
        payload.fax = this.form.fax
        payload.email = this.form.email
        payload.youtubeUri = this.form.youtubeUri
        payload.facebookUri = this.form.facebookUri
        payload.linkedinUri = this.form.linkedinUri
        if (this.isEdit) {
          payload.uuid = this.subOrganizationId
        } else {
          delete payload.uuid
        }
        return payload
      },
      goToEmployerSchools () {
        if (this.employerUuid) {
          this.$router.push({
            name: 'employerDetails',
            params: { uuid: this.employerUuid },
            query: { tab: 'schools' }
          })
          return
        }
        this.$router.push({ name: 'employerAdmin' })
      },
      saveSubOrg () {
        if (!this.form.title || !this.form.title.trim()) {
          this.notifyFailure('Title is required.')
          return
        }
        if (!this.employerUuid || this.submitted) {
          return
        }
        let payload = this.buildPayload()
        this.submitted = true
        let request = this.isEdit ? this.updateSubOrganization(payload) : this.createSubOrganization(payload)
        request.then((response) => {
          this.submitted = false
          if (!response) {
            this.notifyFailure(this.isEdit ? ('Unable to update ' + this.getSubOrgLabel + '.') : ('Unable to create ' + this.getSubOrgLabel + '.'))
            return
          }
          let title = response.title || this.form.title
          this.notifySuccess(this.isEdit ? ('Successfully updated \'' + title + '\'') : ('Successfully created \'' + title + '\''))
          this.goToEmployerSchools()
        }).catch(() => {
          this.submitted = false
          this.notifyFailure(this.isEdit ? ('Unable to update ' + this.getSubOrgLabel + '.') : ('Unable to create ' + this.getSubOrgLabel + '.'))
        })
      },
      cancel () {
        this.goToEmployerSchools()
      },
      notifySuccess (text) {
        return this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        return this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    },
    computed: {
      ...mapState({
        'currentEnvironment': state => state.learningContent.currentEnvironment
      }),
      employerUuid () {
        return this.uuid || (this.$route && this.$route.params && this.$route.params.uuid) || ''
      },
      subOrganizationId () {
        return this.subOrgId || (this.$route && this.$route.params && this.$route.params.subOrgId) || ''
      },
      isEdit () {
        return !!this.subOrganizationId
      },
      pageTitle () {
        return this.isEdit
          ? this.$t('editSchool', { label: this.getSubOrgLabel })
          : this.$t('createSchool', { label: this.getSubOrgLabel })
      },
      logoUploadSpaceId () {
        return this.subOrganizationId || this.employerUuid
      },
      editorInit () {
        return {
          base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
          selector: 'textarea',
          menubar: false,
          plugins: this.plugins,
          toolbar: this.toolbar,
          branding: false,
          statusbar: false,
          end_container_on_empty_block: true
        }
      }
    },
    watch: {
      uuid () {
        this.loadPage()
      },
      subOrgId () {
        this.loadPage()
      }
    }
  }
</script>

<style scoped>
  .job-description-row,
  .job-description-row .col-6,
  .job-description-row .col-7 {
    overflow: visible;
  }

  .job-description-end-col {
    pointer-events: none;
  }

  .job-description-input {
    position: relative;
    z-index: 6;
    max-width: none;
    box-sizing: border-box;
    display: block;
    pointer-events: auto;
  }

  .job-description-input >>> .tox-tinymce,
  .job-description-input >>> .mce-tinymce {
    width: 100% !important;
    box-sizing: border-box;
  }

  .job-description-input >>> .tox-menu,
  .job-description-input >>> .mce-menu,
  .job-description-input >>> .mce-floatpanel,
  .job-description-input >>> .tox-tinymce-aux {
    z-index: 20 !important;
  }

  .employer-top-row {
    align-items: stretch;
  }

  .employer-left-col > .form-label,
  .employer-left-col > .col-7 {
    margin-bottom: 15px;
  }

  .employer-left-col > .form-label:nth-last-child(2),
  .employer-left-col > .col-7:last-child {
    margin-bottom: 0;
  }

  .employer-logo-col {
    align-items: stretch;
  }

  .employer-logo-col .form-label {
    align-self: flex-start;
    padding-top: 6px;
  }

  .employer-logo-col > .col-7 {
    display: flex;
    min-height: 0;
  }

  .hidden-container {
    visibility: hidden;
    height: 1px;
  }

  .employer-logo-box {
    width: 100%;
    height: 100%;
    min-height: 0;
  }

  .employer-logo-box .thumbnail_container .btn {
    position: absolute;
    left: 50%;
    bottom: 8px;
    transform: translateX(-50%);
    z-index: 2;
    height: 32px;
    padding: 0 12px;
    white-space: nowrap;
  }

  .employer-logo-box .thumbnail_container {
    position: relative;
    width: 100%;
    max-width: 240px;
    height: 100%;
    min-height: 96px;
    border: solid 1px rgb(200, 200, 200);
    padding: 4px;
    overflow: hidden;
    text-align: center;
    background: #fff;
  }

  .employer-logo-box .thumbnail_container .ic {
    font-size: 72px;
    height: auto;
    margin: auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8a8a8a;
  }

  .employer-logo-box .thumbnail_container .thumbnail_image,
  .employer-logo-box .thumbnail_container img {
    max-width: 90%;
    max-height: 90%;
    width: auto;
    height: auto;
    margin: auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    object-fit: contain;
  }

</style>



// WEBPACK FOOTER //
// src/app/job/components/CreateEditSubOrg.vue